import React from 'react'

export const FileIcon = ({ children }) => {
  return <span className="file-icon">{children}</span>
}
